import React from 'react';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

interface Props {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
}
export const Layout = ({ children, header, footer }: Props) => {
  return (
    <>
      {!!header && <Header>{header}</Header>}
      <ScrollView>{children}</ScrollView>
      {!!footer && <Footer>{footer}</Footer>}
    </>
  );
};

const footerSlideUp = keyframes`
  from {
    opacity: 0;
    bottom: -100%;
  }
  to {
    opacity: 1;
    bottom: 0;
  }
`;

const Header = styled.div`
  display: flex;
  padding: 0 16px;
  justify-content: space-between;
`;

const ScrollView = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 20px;
  margin-top: 20px;
`;

const Footer = styled.div`
  position: relative;
  animation: ${footerSlideUp} 0.2s ease-in-out;
`;
